var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.230957H24V16.2306H0V0.230957Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21755 0.230957V16.2306H0V0.230957H9.21755Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21777 11.2308C10.8746 11.2308 12.2178 9.88766 12.2178 8.23081C12.2178 6.57395 10.8746 5.2308 9.21777 5.2308C7.56092 5.2308 6.21777 6.57395 6.21777 8.23081C6.21777 9.88766 7.56092 11.2308 9.21777 11.2308Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53027 6.7308V8.60585C7.53027 9.53782 8.2858 10.2934 9.21777 10.2934C10.1497 10.2934 10.9053 9.53782 10.9053 8.60585V6.7308H7.53027Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21777 9.16831C8.9076 9.16831 8.65527 8.91598 8.65527 8.60581V7.8558H9.78032V8.60581C9.78027 8.91593 9.5279 9.16831 9.21777 9.16831Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white",
    transform: "translate(0 0.230774)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/PT.4e93b4ec68bf540dd40f82459e4a0bdf.svg";
export { ForwardRef as ReactComponent };